export default function ClientsDiversConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('clients.divers');
}

ClientsDiversConfiguration.$inject = ['$translatePartialLoaderProvider'];
